import Vue from 'vue'
import Vuex from 'vuex'
import backendApi from '@/api/backend'

Vue.use(Vuex) // to activate vuex

const state = {
  totalInquiries: 0,
  totalSubscribers: 0,
  phoneNumber: {},
  phoneNumberId: 0,
  homeTitleTop: {},
  homeTitleTopId: 0,
  homeTitleMid: {},
  homeTitleMidId: {},
  homeTitleBot: {},
  homeTitleBotId: {},
  homeDynamicText1: {},
  homeDynamicText2: {},
  homeDynamicText3: {},
  aboutTitleTop: {},
  aboutTitleMid: {},
  aboutTitleBot: {},
  aboutDynamicText1: {},
  aboutDynamicText2: {},
  aboutWhyUsTitle1: {},
  aboutWhyUsDescription1: {},
  aboutWhyUsTitle2: {},
  aboutWhyUsDescription2: {},
  aboutWhyUsTitle3: {},
  aboutWhyUsDescription3: {},
  aboutWhyUsTitle4: {},
  aboutWhyUsDescription4: {},
  visionMissionTitle1: {},
  visionMissionDescription1: {},
  visionMissionTitle2: {},
  visionMissionDescription2: {},
  visionMissionTitle3: {},
  visionMissionDescription3: {},
  visionMissionTitle4: {},
  visionMissionDescription4: {},
  visionMissionTitle5: {},
  visionMissionDescription5: {},
  visionMissionTitle6: {},
  visionMissionDescription6: {},
  visionMissionTitle7: {},
  visionMissionDescription7: {},
  visionMissionTitle8: {},
  visionMissionDescription8: {},
  serviceTitleTop: {},
  serviceTitleMid: {},
  serviceTitleBot: {},
  serviceDynamicText1: {},
  serviceDynamicText2: {},
  serviceDynamicText3: {},
  serviceDynamicText4: {},
  serviceDynamicText5: {},
  serviceDynamicText6: {},
  serviceDynamicText7: {},
  serviceDynamicText8: {},
  serviceDynamicText9: {},
  serviceDynamicText10: {},
  serviceDynamicText11: {},
  serviceDynamicText12: {},
  serviceDynamicText13: {},
  projectTitleTop: {},
  projectTitleMid: {},
  projectTitleBot: {},
  productTitleTop: {},
  productTitleMid: {},
  productTitleBot: {},
  contactTitleMid: {},
  contactTitleBot: {},
  contactDynamicText1: {},
  contactDynamicText2: {},
  contactDynamicText3: {},
  contactDynamicText4: {},
  homeDynamicText1Id: {},
  homeDynamicText2Id: {},
  homeDynamicText3Id: {},
  aboutTitleTopId: {},
  aboutTitleMidId: {},
  aboutTitleBotId: {},
  aboutDynamicText1Id: {},
  aboutDynamicText2Id: {},
  aboutWhyUsTitle1Id: {},
  aboutWhyUsDescription1Id: {},
  aboutWhyUsTitle2Id: {},
  aboutWhyUsDescription2Id: {},
  aboutWhyUsTitle3Id: {},
  aboutWhyUsDescription3Id: {},
  aboutWhyUsTitle4Id: {},
  aboutWhyUsDescription4Id: {},
  visionMissionTitle1Id: {},
  visionMissionDescription1Id: {},
  visionMissionTitle2Id: {},
  visionMissionDescription2Id: {},
  visionMissionTitle3Id: {},
  visionMissionDescription3Id: {},
  visionMissionTitle4Id: {},
  visionMissionDescription4Id: {},
  visionMissionTitle5Id: {},
  visionMissionDescription5Id: {},
  visionMissionTitle6Id: {},
  visionMissionDescription6Id: {},
  visionMissionTitle7Id: {},
  visionMissionDescription7Id: {},
  visionMissionTitle8Id: {},
  visionMissionDescription8Id: {},
  serviceTitleTopId: {},
  serviceTitleMidId: {},
  serviceTitleBotId: {},
  serviceDynamicText1Id: {},
  serviceDynamicText2Id: {},
  serviceDynamicText3Id: {},
  serviceDynamicText4Id: {},
  serviceDynamicText5Id: {},
  serviceDynamicText6Id: {},
  serviceDynamicText7Id: {},
  serviceDynamicText8Id: {},
  serviceDynamicText9Id: {},
  serviceDynamicText10Id: {},
  serviceDynamicText11Id: {},
  serviceDynamicText12Id: {},
  serviceDynamicText13Id: {},
  projectTitleTopId: {},
  projectTitleMidId: {},
  projectTitleBotId: {},
  productTitleTopId: {},
  productTitleMidId: {},
  productTitleBotId: {},
  contactTitleMidId: {},
  contactTitleBotId: {},
  contactDynamicText1Id: {},
  contactDynamicText2Id: {},
  contactDynamicText3Id: {},
  contactDynamicText4Id: {},
  aboutUsFooter: {},
  subscribeFooter: {},
  socialMediaFooter: {},
  inquiries: [],
  editingProduct: {},
  editingProject: {},
  products: [],
  projects: [],
  clients: [],
  subscribers: [],
  isLoggedIn: false,
  user: {},
  username: '',
  memberId: '',
  isLoading: false,
  choosingBank: false,
  paymentLimit: 0,
  editingAddress: {},
  countTotalItemInCart: 0,
  deliveryMethod: '',
  choosenOutlet: {
    id: '0',
    name: ''
  },
  totalCartWeight: 0,
  nearestOutlet: {},
  choosenPayment: {
    type: '',
    bankName: ''
  },
  shippingDestination: {
  },
  cart: {
    totalAmount: 0,
    orderAmount: 0,
    shippingAmount: 0,
    deliveryMethod: '',
    outlet: {
      id: '0',
      name: ''
    },
    payment: {
      type: '',
      bankId: '',
      bankName: ''
    },
    cartItems: [],
    shippingDestination: {
    }
  },
  profile: {},
  thankYou: {},
  orderList: {
    ongoing: [],
    finished: [],
    cancelled: []
  },
  pagingOrderOngoing: {},
  pagingOrderDone: {},
  pagingOrderCancelled: {},
  pagingOutlets: {}
}

const mutations = {
  setContentById (state, data) {
    const key = data.data.attributes.key
    const value = data.data.attributes.value
    const id = data.data.id
    if (key === 'cPhoneNumber') {
      state.phoneNumber = value
      state.phoneNumberId = id
    } else if (key === 'homeTitleTop') {
      state.homeTitleTop = value
      state.homeTitleTopId = id
    } else if (key === 'homeTitleMid') {
      state.homeTitleMid = value
      state.homeTitleMidId = id
    } else if (key === 'homeTitleBot') {
      state.homeTitleBot = value
      state.homeTitleBotId = id
    } else if (key === 'homeDynamicText1') {
      state.homeDynamicText1 = value
      state.homeDynamicText1Id = id
    } else if (key === 'homeDynamicText2') {
      state.homeDynamicText2 = value
      state.homeDynamicText2Id = id
    } else if (key === 'homeDynamicText3') {
      state.homeDynamicText3 = value
      state.homeDynamicText3Id = id
    } else if (key === 'aboutTitleTop') {
      state.aboutTitleTop = value
      state.aboutTitleTopId = id
    } else if (key === 'aboutTitleMid') {
      state.aboutTitleMid = value
      state.aboutTitleMidId = id
    } else if (key === 'aboutTitleBot') {
      state.aboutTitleBot = value
      state.aboutTitleBotId = id
    } else if (key === 'aboutDynamicText1') {
      state.aboutDynamicText1 = value
      state.aboutDynamicText1Id = id
    } else if (key === 'aboutDynamicText2') {
      state.aboutDynamicText2 = value
      state.aboutDynamicText2Id = id
    } else if (key === 'aboutWhyUsTitle1') {
      state.aboutWhyUsTitle1 = value
      state.aboutWhyUsTitle1Id = id
    } else if (key === 'aboutWhyUsDescription1') {
      state.aboutWhyUsDescription1 = value
      state.aboutWhyUsDescription1Id = id
    } else if (key === 'aboutWhyUsTitle2') {
      state.aboutWhyUsTitle2 = value
      state.aboutWhyUsTitle2Id = id
    } else if (key === 'aboutWhyUsDescription2') {
      state.aboutWhyUsDescription2 = value
      state.aboutWhyUsDescription2Id = id
    } else if (key === 'aboutWhyUsTitle3') {
      state.aboutWhyUsTitle3 = value
      state.aboutWhyUsTitle3Id = id
    } else if (key === 'aboutWhyUsDescription3') {
      state.aboutWhyUsDescription3 = value
      state.aboutWhyUsDescription3Id = id
    } else if (key === 'aboutWhyUsTitle4') {
      state.aboutWhyUsTitle4 = value
      state.aboutWhyUsTitle4Id = id
    } else if (key === 'aboutWhyUsDescription4') {
      state.aboutWhyUsDescription4 = value
      state.aboutWhyUsDescription4Id = id
    } else if (key === 'visionMissionTitle1') {
      state.visionMissionTitle1 = value
      state.visionMissionTitle1Id = id
    } else if (key === 'visionMissionDescription1') {
      state.visionMissionDescription1 = value
      state.visionMissionDescription1Id = id
    } else if (key === 'visionMissionTitle2') {
      state.visionMissionTitle2 = value
      state.visionMissionTitle2Id = id
    } else if (key === 'visionMissionDescription2') {
      state.visionMissionDescription2 = value
      state.visionMissionDescription2Id = id
    } else if (key === 'visionMissionTitle3') {
      state.visionMissionTitle3 = value
      state.visionMissionTitle3Id = id
    } else if (key === 'visionMissionDescription3') {
      state.visionMissionDescription3 = value
      state.visionMissionDescription3Id = id
    } else if (key === 'visionMissionTitle4') {
      state.visionMissionTitle4 = value
      state.visionMissionTitle4Id = id
    } else if (key === 'visionMissionDescription4') {
      state.visionMissionDescription4 = value
      state.visionMissionDescription4Id = id
    } else if (key === 'visionMissionTitle5') {
      state.visionMissionTitle5 = value
      state.visionMissionTitle5Id = id
    } else if (key === 'visionMissionDescription5') {
      state.visionMissionDescription5 = value
      state.visionMissionDescription5Id = id
    } else if (key === 'visionMissionTitle6') {
      state.visionMissionTitle6 = value
      state.visionMissionTitle6Id = id
    } else if (key === 'visionMissionDescription6') {
      state.visionMissionDescription6 = value
      state.visionMissionDescription6Id = id
    } else if (key === 'visionMissionTitle7') {
      state.visionMissionTitle7 = value
      state.visionMissionTitle7Id = id
    } else if (key === 'visionMissionDescription7') {
      state.visionMissionDescription7 = value
      state.visionMissionDescription7Id = id
    } else if (key === 'visionMissionTitle8') {
      state.visionMissionTitle8 = value
      state.visionMissionTitle8Id = id
    } else if (key === 'visionMissionDescription8') {
      state.visionMissionDescription8 = value
      state.visionMissionDescription8Id = id
    } else if (key === 'serviceTitleTop') {
      state.serviceTitleTop = value
      state.serviceTitleTopId = id
    } else if (key === 'serviceTitleMid') {
      state.serviceTitleMid = value
      state.serviceTitleMidId = id
    } else if (key === 'serviceTitleBot') {
      state.serviceTitleBot = value
      state.serviceTitleBotId = id
    } else if (key === 'serviceDynamicText1') {
      state.serviceDynamicText1 = value
      state.serviceDynamicText1Id = id
    } else if (key === 'serviceDynamicText2') {
      state.serviceDynamicText2 = value
      state.serviceDynamicText2Id = id
    } else if (key === 'serviceDynamicText3') {
      state.serviceDynamicText3 = value
      state.serviceDynamicText3Id = id
    } else if (key === 'serviceDynamicText4') {
      state.serviceDynamicText4 = value
      state.serviceDynamicText4Id = id
    } else if (key === 'serviceDynamicText5') {
      state.serviceDynamicText5 = value
      state.serviceDynamicText5Id = id
    } else if (key === 'serviceDynamicText6') {
      state.serviceDynamicText6 = value
      state.serviceDynamicText6Id = id
    } else if (key === 'serviceDynamicText7') {
      state.serviceDynamicText7 = value
      state.serviceDynamicText7Id = id
    } else if (key === 'serviceDynamicText8') {
      state.serviceDynamicText8 = value
      state.serviceDynamicText8Id = id
    } else if (key === 'serviceDynamicText9') {
      state.serviceDynamicText9 = value
      state.serviceDynamicText9Id = id
    } else if (key === 'serviceDynamicText10') {
      state.serviceDynamicText10 = value
      state.serviceDynamicText10Id = id
    } else if (key === 'serviceDynamicText11') {
      state.serviceDynamicText11 = value
      state.serviceDynamicText11Id = id
    } else if (key === 'serviceDynamicText12') {
      state.serviceDynamicText12 = value
      state.serviceDynamicText12Id = id
    } else if (key === 'serviceDynamicText13') {
      state.serviceDynamicText13 = value
      state.serviceDynamicText13Id = id
    } else if (key === 'projectTitleTop') {
      console.log('project title top ', value)
      console.log('project title top ', id)
      state.projectTitleTop = value
      state.projectTitleTopId = id
    } else if (key === 'projectTitleMid') {
      state.projectTitleMid = value
      state.projectTitleMidId = id
    } else if (key === 'projectTitleBot') {
      state.projectTitleBot = value
      state.projectTitleBotId = id
    } else if (key === 'productTitleTop') {
      state.productTitleTop = value
      state.productTitleTopId = id
    } else if (key === 'productTitleMid') {
      state.productTitleMid = value
      state.productTitleMidId = id
    } else if (key === 'productTitleBot') {
      state.productTitleBot = value
      state.productTitleBotId = id
    } else if (key === 'contactTitleMid') {
      state.contactTitleMid = value
      state.contactTitleMidId = id
    } else if (key === 'contactTitleBot') {
      state.contactTitleBot = value
      state.contactTitleBotId = id
    } else if (key === 'contactDynamicText1') {
      state.contactDynamicText1 = value
      state.contactDynamicText1Id = id
    } else if (key === 'contactDynamicText2') {
      state.contactDynamicText2 = value
      state.contactDynamicText2Id = id
    } else if (key === 'contactDynamicText3') {
      state.contactDynamicText3 = value
      state.contactDynamicText3Id = id
    } else if (key === 'contactDynamicText4') {
      state.contactDynamicText4 = value
      state.contactDynamicText4Id = id
    } else if (key === 'aboutUsFooter') {
      state.aboutUsFooter = value
      state.aboutUsFooterId = id
    } else if (key === 'subscribeFooter') {
      state.subscribeFooter = value
      state.subscribeFooterId = id
    } else if (key === 'socialMediaFooter') {
      state.socialMediaFooter = value
      state.socialMediaFooterId = id
    }
  },
  setPhoneNumber (state, data) {
    state.phoneNumber = data.data
  },
  setInquiries (state, data) {
    state.inquiries = data.inquiries
    state.totalInquiries = data.totalInquiries
  },
  setClients (state, data) {
    state.clients = data.clients
  },
  setProducts (state, data) {
    state.products = data.products
  },
  setProjects (state, data) {
    state.projects = data.projects
  },
  setEditingProduct (state, data) {
    if (data.product.length > 0) {
      state.editingProduct = data.product[0]
    }
  },
  setEditingProject (state, data) {
    state.editingProject = data.project
  },
  deleteProduct (state, data) {
    for (let product in state.products) {
      if (state.products[product].id === data.id) {
        state.products.splice(product, 1)
        break
      }
    }
  },
  deleteProject (state, data) {
    for (let project in state.projects) {
      if (state.projects[project].id === data.id) {
        state.projects.splice(project, 1)
        break
      }
    }
  },
  deleteSubscriber (state, data) {
    for (let index in state.subscribers) {
      if (state.subscribers[index] === data.email) {
        state.subscribers.splice(index, 1)
        break
      }
    }
  },
  setSubscribers (state, data) {
    state.subscribers = data.subscribers
    state.totalSubscribers = data.totalSubscribers
  },
  setIsLoggedInOnly (state, data) {
    state.isLoggedIn = true
  },
  setIsLoggedIn (state, data) {
    state.isLoggedIn = data.isLoggedIn
    state.user = data.user
    if (data.isLoggedIn === false) {
      state.countTotalItemInCart = 0
    }
  },
  setProfile (state, data) {
    state.profile = data
    state.memberId = data.id
  },
  setCart (state, data) {
    state.cart = data.cart
    if (state.cart === null) {
      state.cart = {}
      state.cart.cartItems = []
    }
  },
  setOrderStatus (state, data) {
    for (let order in state.orderList.ongoing) {
      if (state.orderList.ongoing[order].orderNo === data.orderId) {
        state.orderList.ongoing[order].status = data.status
        break
      }
    }
  },
  setOrderList (state, data) {
    if (data.status === 'ongoing') {
      state.orderList.ongoing = data.orderList
      state.pagingOrderOngoing = data.paging
    } else if (data.status === 'finished') {
      state.orderList.finished = data.orderList
      state.pagingOrderDone = data.paging
    } else if (data.status === 'cancelled') {
      state.orderList.cancelled = data.orderList
      state.pagingOrderCancelled = data.paging
    }
  },
  setOutletList (state, data) {
    state.pagingOutlets = data.paging
  },
  addToCart (state, item) {
    if (state.cart.itemListInCart < 1) {
      state.cart.itemListInCart.push(item)
    } else {
      let alreadyInCart = false
      for (let itemInCart in state.cart.itemListInCart) {
        if (state.cart.itemListInCart[itemInCart].id === item.id) {
          state.cart.itemListInCart[itemInCart].quantity += 1
          alreadyInCart = true
        }
      }
      if (!alreadyInCart) {
        state.cart.itemListInCart.push(item)
      }
    }
  },
  resetCartAndSetThankYouPageData (state, data) {
    state.cart = {}
    state.countTotalItemInCart = 0
    state.thankYou = data.thankYou
  },
  calculateGrandTotal (state) {
    if (state.cart !== null) {
      state.cart.orderAmount = 0
      state.countTotalItemInCart = 0
      state.totalCartWeight = 0
      for (let item in state.cart.cartItems) {
        state.totalCartWeight += parseInt(state.cart.cartItems[item].shippingWeight * state.cart.cartItems[item].quantity)
        state.countTotalItemInCart += parseInt(state.cart.cartItems[item].quantity)
        state.cart.orderAmount += state.cart.cartItems[item].quantity * state.cart.cartItems[item].unitPrice
      }
      state.cart.totalAmount = state.cart.orderAmount
    }
  },
  updateCartQuantity (state, data) {
    state.cart.cartItems[data.index].quantity = data.quantity
  },
  removeFromCart (state, data) {
    state.cart.cartItems.splice(data.index, 1)
  },
  setDeliveryMethod (state, data) {
    state.cart.deliveryMethod = data.methodCode
    state.deliveryMethod = data.methodCode
  },
  setNearestOutlet (state, data) {
    // useless
    state.nearestOutlet = data.nearestOutlet
    // will use choosenOutlet
    state.choosenOutlet = data.nearestOutlet
  },
  setPaymentType (state, data) {
    state.choosenPayment.type = data.paymentType
    if (data.paymentType !== 'transfer') {
      state.choosenPayment.bankId = ''
      state.choosenPayment.bankName = ''
    }
  },
  setEditingAddress (state, data) {
    state.editingAddress = data.address
  },
  setChoosingBank (state, data) {
    state.choosingBank = data.choosingBank
  },
  chooseBank (state, data) {
    state.choosenPayment.bankId = data.bankId
    state.choosenPayment.bankName = data.bankName
    state.choosenPayment.paymentMethod = data.paymentMethod
  },
  setOutletId (state, data) {
    state.choosenOutlet.id = data.outletId
    state.choosenOutlet.name = data.outletName
  },
  setAddressDestination (state, data) {
    state.shippingDestination = data.address
  },
  addNewAddress (state, data) {
    if (state.profile.shippingAddresses === undefined) {
      state.profile.shippingAddresses = []
    }
    state.profile.shippingAddresses.unshift(data.address)
  },
  getProductDetailByProductId (state, data) {
    console.log('success get Product Detail for ' + data.id)
  },
  getProductListByCategoryName (state, data) {
    console.log('success get productList by categoryName: ' + data.categoryName)
  }
}

const actions = {
  findContentById ({commit}, {data, success, fail} = {}) {
    backendApi.findContentById((res) => {
      commit('setContentById', {
        data: res.body.data
      })
      success && success(res)
    }, data, fail)
  },
  findAllContents ({commit}, {data, success, fail} = {}) {
    backendApi.findAllContents((res) => {
      for (let counter in res.body.data) {
        commit('setContentById', {
          data: res.body.data[counter]
        })
      }

      // for (let product in state.products) {
      //   if (state.products[product].id === data.id) {

      success && success(res)
    }, data, fail)
  },
  uploadFile ({commit}, {data, success, fail} = {}) {
    backendApi.uploadFile((res) => {
      success && success(res)
    }, data, fail)
  },
  deleteFile ({commit}, {data, success, fail} = {}) {
    backendApi.deleteFile((res) => {
      success && success(res)
    }, data, fail)
  },
  saveContentById ({commit, dispatch}, {data, success, fail} = {}) {
    backendApi.editContentById((res) => {
      commit('setContentById', {
        data: res.body.data
      })
      success && success(res)
    }, data, fail)
  },
  createClient ({commit, dispatch}, {data, success, fail} = {}) {
    backendApi.createClient((res) => {
      success && success(res)
    }, data, fail)
  },
  editClient ({commit, dispatch}, {data, success, fail} = {}) {
    backendApi.editClient((res) => {
      success && success(res)
    }, data, fail)
  },
  deleteClient ({commit, dispatch}, {data, success, fail} = {}) {
    backendApi.deleteClient((res) => {
      success && success(res)
    }, data, (response) => {
      fail && fail(response)
    })
  },
  findAllClients ({commit}, {data, success, fail} = {}) {
    backendApi.findAllClients((res) => {
      success && success(res)
    }, data, fail)
  },
  findClientById ({commit}, {data, success, fail} = {}) {
    backendApi.findClientById((res) => {
      commit('setEditingClient', {
        project: res.body.data
      })
      success && success(res)
    }, data, fail)
  },
  createProject ({commit, dispatch}, {data, success, fail} = {}) {
    backendApi.createProject((res) => {
      success && success(res)
    }, data, fail)
  },
  editProject ({commit, dispatch}, {data, success, fail} = {}) {
    backendApi.editProject((res) => {
      success && success(res)
    }, data, fail)
  },
  deleteProject ({commit, dispatch}, {data, success, fail} = {}) {
    backendApi.deleteProject((res) => {
      commit('deleteProject', {
        id: data.id
      })
      success && success(res)
    }, data, (response) => {
      fail && fail(response)
    })
  },
  findAllProjects ({commit}, {data, success, fail} = {}) {
    backendApi.findAllProjects((res) => {
      commit('setProjects', {
        projects: res.body.data.content,
        paging: res.body.pageable
      })
      success && success(res)
    }, data, fail)
  },
  findProjectById ({commit}, {data, success, fail} = {}) {
    backendApi.findProjectById((res) => {
      if (res.body.data.length > 0) {
        commit('setEditingProject', {
          project: res.body.data[0]
        })
      }
      success && success(res)
    }, data, fail)
  },
  createProduct ({commit, dispatch}, {data, success, fail} = {}) {
    backendApi.createProduct((res) => {
      success && success(res)
    }, data, fail)
  },
  editProduct ({commit, dispatch}, {data, success, fail} = {}) {
    backendApi.editProduct((res) => {
      success && success(res)
    }, data, fail)
  },
  deleteProduct ({commit, dispatch}, {data, success, fail} = {}) {
    backendApi.deleteProduct((res) => {
      success && success(res)
    }, data, (response) => {
      fail && fail(response)
    })
  },
  findAllProducts ({commit}, {data, success, fail} = {}) {
    backendApi.findAllProducts((res) => {
      commit('setProducts', {
        products: res.body.data.content,
        paging: res.body.pageable
      })
      success && success(res)
    }, data, fail)
  },
  findProductById ({commit}, {data, success, fail} = {}) {
    backendApi.findProductById((res) => {
      commit('setEditingProduct', {
        product: res.body.data
      })
      success && success(res)
    }, data, fail)
  },
  login ({commit, dispatch}, {data, success, fail} = {}) {
    backendApi.login((res) => {
      success && success(res)
    }, data, fail)
  },
  createInquiry ({commit, dispatch}, {data, success, fail} = {}) {
    backendApi.createInquiry((res) => {
      success && success(res)
    }, data, fail)
  },
  sendMessage ({commit, dispatch}, {data, success, fail} = {}) {
    backendApi.sendMessage((res) => {
      success && success(res)
    }, data, fail)
  },
  getAllInquiries ({commit}, {data, success, fail} = {}) {
    backendApi.getAllInquiries((res) => {
      commit('setInquiries', {
        inquiries: res.body.data.content,
        paging: res.body.pageable,
        totalInquiries: res.body.data.totalElements
      })
      success && success(res)
    }, data, fail)
  },
  subscribe ({commit, dispatch}, {data, success, fail} = {}) {
    backendApi.subscribe((res) => {
      success && success(res)
    }, data, fail)
  },
  unsubscribe ({commit, dispatch}, {data, success, fail} = {}) {
    backendApi.unsubscribe((res) => {
      commit('deleteSubscriber', {
        email: data.email
      })
      success && success(res)
    }, data, (response) => {
      fail && fail(response)
    })
    commit('deleteSubscriber', {
      email: data.email
    })
  },
  findAllSubscribers ({commit}, {data, success, fail} = {}) {
    backendApi.findAllSubscribers((res) => {
      commit('setSubscribers', {
        subscribers: res.body.data.content,
        paging: res.body.pageable,
        totalSubscribers: res.body.data.totalElements
      })
      success && success(res)
    }, data, fail)
  },
  changePassword ({commit, dispatch}, {data, success, fail} = {}) {
    backendApi.changePassword((res) => {
      success && success(res)
    }, data, fail)
  },
  signUp ({commit, dispatch}, {data, success, fail} = {}) {
    backendApi.signUp((res) => {
      success && success(res)
    }, data, fail)
  },
  signIn ({commit, dispatch}, {data, success, fail} = {}) {
    backendApi.signIn((res) => {
      success && success(res)
    }, data, fail)
  },
  setIsLoggedInOnly ({commit}, {data, success, fail} = {}) {
    commit('setIsLoggedInOnly')
    success && success()
  },
  setIsLoggedIn ({commit}, {data, success, fail} = {}) {
    commit('setIsLoggedIn', {
      isLoggedIn: data.isLoggedIn,
      user: data.user
    })
    success && success()
  },
  getProfile ({commit}, {data, success, fail} = {}) {
    backendApi.getProfile((res) => {
      commit('setProfile', res.body.data)
      success && success(res)
    }, data, fail)
  },
  addAddress ({commit, dispatch}, {data, success, fail} = {}) {
    backendApi.addAddress((res) => {
      success && success(res)
    }, data, fail)
  },
  removeAddress ({commit, dispatch}, {data, success, fail} = {}) {
    backendApi.removeAddress((res) => {
      success && success(res)
    }, data, (response) => {
      fail && fail(response)
    })
  },
  editAddress ({commit}, {data, success, fail} = {}) {
    backendApi.editAddress((res) => {
      success && success(res)
    }, data, fail)
  },
  calculateShippingCost ({commit}, {data, success, fail} = {}) {
    backendApi.calculateShippingCost((res) => {
      success && success(res)
    }, data, fail)
  },
  getNearestOutlet ({commit}, {data, success, fail} = {}) {
    backendApi.getNearestOutlet((res) => {
      success && success(res)
      commit('setNearestOutlet', {
        nearestOutlet: res.body.data
      })
    }, data, fail)
  },
  addToCart ({commit, state}, {data, success, fail} = {}) {
    backendApi.addToCart((res) => {
      success && success(res)
      commit('setCart', {
        cart: res.body.data
      })
      commit('calculateGrandTotal')
    }, data, fail)
  },
  checkout ({commit, state}, {data, success, fail} = {}) {
    backendApi.checkout((res) => {
      success && success(res)
      commit('resetCartAndSetThankYouPageData', {
        thankYou: res.body.data
      })
    }, data, fail)
  },
  updateCart ({commit, state}, {data, success, fail} = {}) {
    backendApi.updateCart((res) => {
      success && success(res)
      commit('setCart', {
        cart: res.body.data
      })
      commit('calculateGrandTotal')
    }, data, fail)
  },
  removeCart ({commit, dispatch}, {data, success, fail} = {}) {
    backendApi.removeCart((res) => {
      success && success(res)
    }, data, (response) => {
      fail && fail(response)
    })
  },
  updateCartQuantity ({commit, state}, data) {
    commit('updateCartQuantity', {
      index: data.index,
      quantity: data.quantity
    })
    // always need to calculate again
    commit('calculateGrandTotal')
  },
  removeFromCart ({commit, state}, data) {
    commit('removeFromCart', {
      index: data.index
    })
    // always need to calculate again
    commit('calculateGrandTotal')
  },
  setDeliveryMethod ({commit, state}, data) {
    commit('setDeliveryMethod', {
      methodCode: data.methodCode
    })
  },
  setEditingAddress ({commit, state}, data) {
    commit('setEditingAddress', {
      address: data.address
    })
  },
  setChoosingBank ({commit, state}, data) {
    commit('setChoosingBank', {
      choosingBank: data.choosingBank
    })
  },
  setOutletId ({commit, state}, data) {
    commit('setOutletId', {
      outletId: data.outletId,
      outletName: data.outletName
    })
  },
  setAddressDestination ({commit, state}, data) {
    commit('setAddressDestination', {
      address: data.address
    })
  },
  chooseBank ({commit, state}, data) {
    commit('chooseBank', {
      bankId: data.bankId,
      bankName: data.bankName,
      paymentMethod: data.paymentMethod
    })
    commit('setPaymentType', {
      paymentType: data.paymentType
    })
    commit('setChoosingBank', {
      choosingBank: false
    })
  },
  setPaymentType ({commit, state}, data) {
    commit('setPaymentType', {
      paymentType: data.paymentType
    })
  },
  setNearestOutlet ({commit, state}, data) {
    commit('setNearestOutlet', {
      nearestOutlet: data.nearestOutlet
    })
  },
  addNewAddress ({commit, state}, data) {
    commit('addNewAddress', {
      address: data.address
    })
  },
  getProductDetailByProductId ({commit, state}, data) {
    commit('getProductDetailByProductId', {
      id: data.id
    })
  },
  getProductListByCategoryName ({commit, state}, data) {
    commit('getProductListByCategoryName', {
      categoryName: data.categoryName
    })
  },
  getProvinceList ({commit}, {data, success, fail} = {}) {
    backendApi.getProvinceList((res) => {
      success && success(res)
    }, data, fail)
  },
  getCityList ({commit}, {data, success, fail} = {}) {
    backendApi.getCityList((res) => {
      success && success(res)
    }, data, fail)
  },
  getDistrictList ({commit}, {data, success, fail} = {}) {
    backendApi.getDistrictList((res) => {
      success && success(res)
    }, data, fail)
  },
  getSubDistrictList ({commit}, {data, success, fail} = {}) {
    backendApi.getSubDistrictList((res) => {
      success && success(res)
    }, data, fail)
  },
  getPostalCodeList ({commit}, {data, success, fail} = {}) {
    backendApi.getPostalCodeList((res) => {
      success && success(res)
    }, data, fail)
  },
  getAllOutlet ({commit}, {data, success, fail} = {}) {
    backendApi.getAllOutlet((res) => {
      commit('setOutletList', {
        paging: res.body.paging
      })
      success && success(res)
    }, data, fail)
  },
  getProductList ({commit}, {data, success, fail} = {}) {
    backendApi.getProductList((res) => {
      success && success(res)
    }, data, fail)
  },
  getProjectList ({commit}, {data, success, fail} = {}) {
    backendApi.getProjectList((res) => {
      success && success(res)
    }, data, fail)
  },
  getProductListByName ({commit}, {data, success, fail} = {}) {
    backendApi.getProductListByName((res) => {
      success && success(res)
    }, data, fail)
  },
  getProductDetail ({commit}, {data, success, fail} = {}) {
    backendApi.getProductDetail((res) => {
      success && success(res)
    }, data, fail)
  },
  getCartById ({commit}, {data, success, fail} = {}) {
    backendApi.getCartById((res) => {
      success && success(res)
      commit('setCart', {
        cart: res.body.data
      })
      commit('calculateGrandTotal')
    }, data, fail)
  },
  getOrderList ({commit}, {data, success, fail} = {}) {
    backendApi.getOrderList((res) => {
      success && success(res)
      commit('setOrderList', {
        orderList: res.body.data,
        status: data.status,
        paging: res.body.paging
      })
    }, data, fail)
  },
  confirmPayment ({commit}, {data, success, fail} = {}) {
    backendApi.confirmPayment((res) => {
      success && success(res)
      commit('setOrderStatus', {
        orderId: data.orderId,
        status: 'C'
      })
    }, data, fail)
  },
  confirmDelivery ({commit}, {data, success, fail} = {}) {
    backendApi.confirmDelivery((res) => {
      success && success(res)
      commit('setOrderStatus', {
        orderId: data.orderId,
        status: 'D'
      })
    }, data, fail)
  }
}

const getters = {
  phoneNumber (state) {
    return state.phoneNumber
  },
  phoneNumberId (state) {
    return state.phoneNumberId
  },
  homeTitleTop (state) {
    return state.homeTitleTop
  },
  homeTitleTopId (state) {
    return state.homeTitleTopId
  },
  homeTitleMid (state) {
    return state.homeTitleMid
  },
  homeTitleMidId (state) {
    return state.homeTitleMidId
  },
  homeTitleBot (state) {
    return state.homeTitleBot
  },
  homeTitleBotId (state) {
    return state.homeTitleBotId
  },
  homeDynamicText1 (state) {
    return state.homeDynamicText1
  },
  homeDynamicText1Id (state) {
    return state.homeDynamicText1Id
  },
  homeDynamicText2 (state) {
    return state.homeDynamicText2
  },
  homeDynamicText2Id (state) {
    return state.homeDynamicText2Id
  },
  homeDynamicText3 (state) {
    return state.homeDynamicText3
  },
  homeDynamicText3Id (state) {
    return state.homeDynamicText3Id
  },
  aboutTitleTop (state) {
    return state.aboutTitleTop
  },
  aboutTitleTopId (state) {
    return state.aboutTitleTopId
  },
  aboutTitleMid (state) {
    return state.aboutTitleMid
  },
  aboutTitleMidId (state) {
    return state.aboutTitleMidId
  },
  aboutTitleBot (state) {
    return state.aboutTitleBot
  },
  aboutTitleBotId (state) {
    return state.aboutTitleBotId
  },
  aboutDynamicText1 (state) {
    return state.aboutDynamicText1
  },
  aboutDynamicText1Id (state) {
    return state.aboutDynamicText1Id
  },
  aboutDynamicText2 (state) {
    return state.aboutDynamicText2
  },
  aboutDynamicText2Id (state) {
    return state.aboutDynamicText2Id
  },
  aboutWhyUsTitle1 (state) {
    return state.aboutWhyUsTitle1
  },
  aboutWhyUsTitle1Id (state) {
    return state.aboutWhyUsTitle1Id
  },
  aboutWhyUsDescription1 (state) {
    return state.aboutWhyUsDescription1
  },
  aboutWhyUsDescription1Id (state) {
    return state.aboutWhyUsDescription1Id
  },
  aboutWhyUsTitle2 (state) {
    return state.aboutWhyUsTitle2
  },
  aboutWhyUsTitle2Id (state) {
    return state.aboutWhyUsTitle2Id
  },
  aboutWhyUsDescription2 (state) {
    return state.aboutWhyUsDescription2
  },
  aboutWhyUsDescription2Id (state) {
    return state.aboutWhyUsDescription2Id
  },
  aboutWhyUsTitle3 (state) {
    return state.aboutWhyUsTitle3
  },
  aboutWhyUsTitle3Id (state) {
    return state.aboutWhyUsTitle3Id
  },
  aboutWhyUsDescription3 (state) {
    return state.aboutWhyUsDescription3
  },
  aboutWhyUsDescription3Id (state) {
    return state.aboutWhyUsDescription3Id
  },
  aboutWhyUsTitle4 (state) {
    return state.aboutWhyUsTitle4
  },
  aboutWhyUsTitle4Id (state) {
    return state.aboutWhyUsTitle4Id
  },
  aboutWhyUsDescription4 (state) {
    return state.aboutWhyUsDescription4
  },
  aboutWhyUsDescription4Id (state) {
    return state.aboutWhyUsDescription4Id
  },
  visionMissionTitle1 (state) {
    return state.visionMissionTitle1
  },
  visionMissionTitle1Id (state) {
    return state.visionMissionTitle1Id
  },
  visionMissionDescription1 (state) {
    return state.visionMissionDescription1
  },
  visionMissionDescription1Id (state) {
    return state.visionMissionDescription1Id
  },
  visionMissionTitle2 (state) {
    return state.visionMissionTitle2
  },
  visionMissionTitle2Id (state) {
    return state.visionMissionTitle2Id
  },
  visionMissionDescription2 (state) {
    return state.visionMissionDescription2
  },
  visionMissionDescription2Id (state) {
    return state.visionMissionDescription2Id
  },
  visionMissionTitle3 (state) {
    return state.visionMissionTitle3
  },
  visionMissionTitle3Id (state) {
    return state.visionMissionTitle3Id
  },
  visionMissionDescription3 (state) {
    return state.visionMissionDescription3
  },
  visionMissionDescription3Id (state) {
    return state.visionMissionDescription3Id
  },
  visionMissionTitle4 (state) {
    return state.visionMissionTitle4
  },
  visionMissionTitle4Id (state) {
    return state.visionMissionTitle4Id
  },
  visionMissionDescription4 (state) {
    return state.visionMissionDescription4
  },
  visionMissionDescription4Id (state) {
    return state.visionMissionDescription4Id
  },
  visionMissionTitle5 (state) {
    return state.visionMissionTitle5
  },
  visionMissionTitle5Id (state) {
    return state.visionMissionTitle5Id
  },
  visionMissionDescription5 (state) {
    return state.visionMissionDescription5
  },
  visionMissionDescription5Id (state) {
    return state.visionMissionDescription5Id
  },
  visionMissionTitle6 (state) {
    return state.visionMissionTitle6
  },
  visionMissionTitle6Id (state) {
    return state.visionMissionTitle6Id
  },
  visionMissionDescription6 (state) {
    return state.visionMissionDescription6
  },
  visionMissionDescription6Id (state) {
    return state.visionMissionDescription6Id
  },
  visionMissionTitle7 (state) {
    return state.visionMissionTitle7
  },
  visionMissionTitle7Id (state) {
    return state.visionMissionTitle7Id
  },
  visionMissionDescription7 (state) {
    return state.visionMissionDescription7
  },
  visionMissionDescription7Id (state) {
    return state.visionMissionDescription7Id
  },
  visionMissionTitle8 (state) {
    return state.visionMissionTitle8
  },
  visionMissionTitle8Id (state) {
    return state.visionMissionTitle8Id
  },
  visionMissionDescription8 (state) {
    return state.visionMissionDescription8
  },
  visionMissionDescription8Id (state) {
    return state.visionMissionDescription8Id
  },
  serviceTitleTop (state) {
    return state.serviceTitleTop
  },
  serviceTitleTopId (state) {
    return state.serviceTitleTopId
  },
  serviceTitleMid (state) {
    return state.serviceTitleMid
  },
  serviceTitleMidId (state) {
    return state.serviceTitleMidId
  },
  serviceTitleBot (state) {
    return state.serviceTitleBot
  },
  serviceTitleBotId (state) {
    return state.serviceTitleBotId
  },
  serviceDynamicText1 (state) {
    return state.serviceDynamicText1
  },
  serviceDynamicText1Id (state) {
    return state.serviceDynamicText1Id
  },
  serviceDynamicText2 (state) {
    return state.serviceDynamicText2
  },
  serviceDynamicText2Id (state) {
    return state.serviceDynamicText2Id
  },
  serviceDynamicText3 (state) {
    return state.serviceDynamicText3
  },
  serviceDynamicText3Id (state) {
    return state.serviceDynamicText3Id
  },
  serviceDynamicText4 (state) {
    return state.serviceDynamicText4
  },
  serviceDynamicText4Id (state) {
    return state.serviceDynamicText4Id
  },
  serviceDynamicText5 (state) {
    return state.serviceDynamicText5
  },
  serviceDynamicText5Id (state) {
    return state.serviceDynamicText5Id
  },
  serviceDynamicText6 (state) {
    return state.serviceDynamicText6
  },
  serviceDynamicText6Id (state) {
    return state.serviceDynamicText6Id
  },
  serviceDynamicText7 (state) {
    return state.serviceDynamicText7
  },
  serviceDynamicText7Id (state) {
    return state.serviceDynamicText7Id
  },
  serviceDynamicText8 (state) {
    return state.serviceDynamicText8
  },
  serviceDynamicText8Id (state) {
    return state.serviceDynamicText8Id
  },
  serviceDynamicText9 (state) {
    return state.serviceDynamicText9
  },
  serviceDynamicText9Id (state) {
    return state.serviceDynamicText9Id
  },
  serviceDynamicText10 (state) {
    return state.serviceDynamicText10
  },
  serviceDynamicText10Id (state) {
    return state.serviceDynamicText10Id
  },
  serviceDynamicText11 (state) {
    return state.serviceDynamicText11
  },
  serviceDynamicText11Id (state) {
    return state.serviceDynamicText11Id
  },
  serviceDynamicText12 (state) {
    return state.serviceDynamicText12
  },
  serviceDynamicText12Id (state) {
    return state.serviceDynamicText12Id
  },
  serviceDynamicText13 (state) {
    return state.serviceDynamicText13
  },
  serviceDynamicText13Id (state) {
    return state.serviceDynamicText13Id
  },
  projectTitleTop (state) {
    return state.projectTitleTop
  },
  projectTitleTopId (state) {
    return state.projectTitleTopId
  },
  projectTitleMid (state) {
    return state.projectTitleMid
  },
  projectTitleMidId (state) {
    return state.projectTitleMidId
  },
  projectTitleBot (state) {
    return state.projectTitleBot
  },
  projectTitleBotId (state) {
    return state.projectTitleBotId
  },
  productTitleTop (state) {
    return state.productTitleTop
  },
  productTitleTopId (state) {
    return state.productTitleTopId
  },
  productTitleMid (state) {
    return state.productTitleMid
  },
  productTitleMidId (state) {
    return state.productTitleMidId
  },
  productTitleBot (state) {
    return state.productTitleBot
  },
  productTitleBotId (state) {
    return state.productTitleBotId
  },
  contactTitleMid (state) {
    return state.contactTitleMid
  },
  contactTitleMidId (state) {
    return state.contactTitleMidId
  },
  contactTitleBot (state) {
    return state.contactTitleBot
  },
  contactTitleBotId (state) {
    return state.contactTitleBotId
  },
  contactDynamicText1 (state) {
    return state.contactDynamicText1
  },
  contactDynamicText1Id (state) {
    return state.contactDynamicText1Id
  },
  contactDynamicText2 (state) {
    return state.contactDynamicText2
  },
  contactDynamicText2Id (state) {
    return state.contactDynamicText2Id
  },
  contactDynamicText3 (state) {
    return state.contactDynamicText3
  },
  contactDynamicText3Id (state) {
    return state.contactDynamicText3Id
  },
  contactDynamicText4 (state) {
    return state.contactDynamicText4
  },
  contactDynamicText4Id (state) {
    return state.contactDynamicText4Id
  },
  aboutUsFooter (state) {
    return state.aboutUsFooter
  },
  aboutUsFooterId (state) {
    return state.aboutUsFooterId
  },
  subscribeFooter (state) {
    return state.subscribeFooter
  },
  subscribeFooterId (state) {
    return state.subscribeFooterId
  },
  socialMediaFooter (state) {
    return state.socialMediaFooter
  },
  socialMediaFooterId (state) {
    return state.socialMediaFooterId
  },
  totalSubscribers (state) {
    return state.totalSubscribers
  },
  totalInquiries (state) {
    return state.totalInquiries
  },
  inquiries (state) {
    return state.inquiries
  },
  editingProduct (state) {
    return state.editingProduct
  },
  editingProject (state) {
    return state.editingProject
  },
  clients (state) {
    return state.clients
  },
  products (state) {
    return state.products
  },
  projects (state) {
    return state.projects
  },
  subscribers (state) {
    return state.subscribers
  },
  profile (state) {
    return state.profile
  },
  isLoggedIn (state) {
    return state.isLoggedIn
  },
  user (state) {
    return state.user
  },
  memberId (state) {
    return state.memberId
  },
  countTotalItemInCart (state) {
    return state.countTotalItemInCart
  },
  deliveryMethod (state) {
    return state.deliveryMethod
  },
  cart (state) {
    return state.cart
  },
  nearestOutlet (state) {
    return state.nearestOutlet
  },
  choosenOutlet (state) {
    return state.choosenOutlet
  },
  shippingDestination (state) {
    return state.shippingDestination
  },
  thankYou (state) {
    return state.thankYou
  },
  ongoingOrderList (state) {
    return state.orderList.ongoing
  },
  finishedOrderList (state) {
    return state.orderList.finished
  },
  cancelledOrderList (state) {
    return state.orderList.cancelled
  },
  pagingOrderOngoing (state) {
    return state.pagingOrderOngoing
  },
  pagingOrderDone (state) {
    return state.pagingOrderDone
  },
  pagingOrderCancelled (state) {
    return state.pagingOrderCancelled
  },
  pagingOutlets (state) {
    return state.pagingOutlets
  }
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})



// WEBPACK FOOTER //
// ./src/store/store.js